import CustomCheckBox from './customCheckBox';

export default CustomCheckBox;